define('infoArchitecture/siteMap',[
    'lib/lodash4'
], function (_) {
    'use strict';

    /**
     * A simple structured object that maps to the
     * site hierarchy. It's the official site structure,
     * and is used to generate breadcrumbs
     * (working up from a given node).
     *
     * As unlikely as it is to happen, it's worth noting
     * that no breadcrumb should be named parent or label.
     */
    var siteMap = {
        dashboard: {
            interactionDetails: {}
        },
        scripts: {
            createScript: {},
            scriptEditor: {}
        },
        scriptTemplates: {},
        interactionsList: {
            interactionDetails: {}
        },
        myAccount: {},
        queues: {
            queueDetails: {}
        },
        quality: {
            prefix: 'quality',
            evaluationForms: {
                evaluationFormEditor: {}
            },
            surveyForms: {
                surveyFormEditor: {}
            }
        },
        support: {}
    };

    var pendingDependentEntries = {};

    /**
     * Recursively finds any component entries that are dependent on
     * (live in) another component's navigation and adds them to that component
     */
    var registerDependentEntries = function (entries, parent) {
        _.each(entries, function (entry, key) {
            if (key !== '_label' && key !== '_token' && key !== '_parent' &&
                key !== '_hash' && key !== 'isStaticBreadcrumb') {
                
                if (parent[key]) {
                    registerDependentEntries(entry, parent[key]);
                } else {
                    entry._parent = parent;
                    parent[key] = entry;
                }
            }
        });
    };

    /**
     * Recursively decorates all children of the provided page
     */
    var decorateRecursive = function (page, name, labelPrefix) {
        labelPrefix = labelPrefix || page.prefix;

        _.each(page, function (childPage, key) {
            if(key === "prefix") {
                return;
            }

            decorateRecursive(childPage, key, labelPrefix);
            childPage._parent = page;
        });

        //TODO: these can collide - rework to be based on full path of map.
        page._label = 'siteMap.' + name;
        if (labelPrefix) {
            page._label = labelPrefix + '.' + page._label;
        }
        page._token = name;
    };

    decorateRecursive(siteMap, 'home');

    // Manually add the hash for the root element, since we don't
    // register a route for it.
    siteMap._hash = '#';

    // TODO: refactor this off of the map defintion
    siteMap.registerEntries = function (entries, labelPrefix, navParent) {
        if (navParent) {
            _.each(entries, function (entry, key) {
                decorateRecursive(entry, key, labelPrefix);
            });

            // Add the entries to the parent component or store them until the parent component is added
            var nestedEntries = labelPrefix ? entries[labelPrefix] : entries;
            if (!siteMap[navParent]) {
                pendingDependentEntries[navParent] = nestedEntries;
            } else {
                registerDependentEntries(nestedEntries, siteMap[navParent]);
            }
        } else {
            _.each(entries, function (entry, key) {
                decorateRecursive(entry, key, labelPrefix);
                entry._parent = siteMap;
            });

            // If we have any dependent entries waiting on a parent component, check if the parent
            // has been added yet and add them if it has
            if (_.keys(pendingDependentEntries).length > 0) {
                _.each(pendingDependentEntries, function (dependentEntry, parentKey) {
                    if (siteMap[parentKey] || (labelPrefix && labelPrefix === parentKey)) {
                        var parentMap = siteMap[parentKey] || entries[parentKey];
                        registerDependentEntries(dependentEntry, parentMap);
                        delete pendingDependentEntries[parentKey];
                    }
                });
            }

            _.assign(siteMap, entries);
        }
    };

    return siteMap;
});

